import { render, staticRenderFns } from "./LearningOutcomesField.vue?vue&type=template&id=7e38c954"
import script from "./LearningOutcomesField.vue?vue&type=script&lang=js"
export * from "./LearningOutcomesField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports